import { useAuthenticatedSwr } from 'shared/hooks/useAuthenticatedSwr';
import { IWantEntry } from 'wants/types/WantEntry';

interface IWantedProductTemplatesResponse {
  wants: IWantEntry[];
}

export const useWantedEntries = () => {
  const { data, mutate, error, ...rest } = useAuthenticatedSwr<IWantedProductTemplatesResponse>(
    '/web-api/v1/wants/wanted_product_templates',
  );

  return { ...rest, wantEntries: data?.wants, error, mutate };
};
